module.exports = __webpack_public_path__ + "img/gray-video.7353b6e5.svg";